/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Exercise_Excluded_ToastInputs */

const en_us2_exercise_excluded_toast = /** @type {(inputs: Exercise_Excluded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} won't be suggested again`)
};

const pt_br2_exercise_excluded_toast = /** @type {(inputs: Exercise_Excluded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} não será mais sugerido`)
};

const es_419_exercise_excluded_toast = /** @type {(inputs: Exercise_Excluded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ya no se sugerirá`)
};

const pt_pt2_exercise_excluded_toast = /** @type {(inputs: Exercise_Excluded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} não voltará a ser sugerido`)
};

const fr_fr2_exercise_excluded_toast = /** @type {(inputs: Exercise_Excluded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ne sera plus suggéré`)
};

const de_de2_exercise_excluded_toast = /** @type {(inputs: Exercise_Excluded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} wird nicht mehr vorgeschlagen`)
};

const it_it2_exercise_excluded_toast = /** @type {(inputs: Exercise_Excluded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} non verrà più suggerito`)
};

/**
* | output |
* | --- |
* | "{name} won't be suggested again" |
*
* @param {Exercise_Excluded_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_excluded_toast = /** @type {((inputs: Exercise_Excluded_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Excluded_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_excluded_toast(inputs)
	if (locale === "es-419") return es_419_exercise_excluded_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_excluded_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_excluded_toast(inputs)
	if (locale === "de-DE") return de_de2_exercise_excluded_toast(inputs)
	if (locale === "it-IT") return it_it2_exercise_excluded_toast(inputs)
	return en_us2_exercise_excluded_toast(inputs)
});
export { exercise_excluded_toast as "exercise.excluded_toast" }